import React, { useEffect, useState } from 'react';
import CategoryBox from './CategoryBox';
import RightContentBox from './RightContentBox';

import { Container, Grid } from '@material-ui/core';
import axios from 'axios';
import { useLocation } from 'react-router-dom';
import Constants from '../../App/Variables/Constants';
import queryString from 'query-string';
// console.log(queryString.parse(window.location.search))
// console.log(user_id)
const AddProductToShare = ({ }) => {
  const user_id = queryString.parse(window.location.search).user_id;
  console.log(user_id)
  const [category, setCategory] = useState([]);

  const handleCategoryCheck = (id) => {
    // setCategory(id == category ? '' : id);
    if (category.includes(id)) {
      const cats = category.filter(ca => ca != id);
      setCategory(cats)
    } else {
      setCategory([...category, id])
    }
  };

  const [categories, setCategories] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  const [share, setShare] = useState(null);

  const location = useLocation();

  useEffect(() => {
    (async () => {
      const shareId = location.pathname?.split?.('/')?.pop?.();
      setIsLoading(true);

      if (!shareId) {
        setIsLoading(false);
        return;
      }
      try {
        const { data: shareData } = await axios.get(
          `${Constants.getUrls.share_products}/${shareId}?user=${user_id}`
        );
        setShare(shareData.shareProduct);
        const { data } = await axios.get(Constants.getUrls.Categories);
        setCategories(data.categories.docs);
        // setCategory([data.categories.docs[0]._id]);
      } catch (err) {
      } finally {
        setIsLoading(false);
      }
    })();
  }, []);
  if (isLoading) return null;

  if (!isLoading && !share)
    return (
      <div
        id="scrollableDiv"
        style={{
          fontSize: 20,
          fontWeight: 500,
          color: 'red',
          textAlign: 'center',
          fontStyle: 'italic',
          padding: 20,
          minHeight: '60vh',
        }}
      >
        No Data Found
      </div>
    );
  return (
    <Container className="containerSpacingdashBoard" maxWidth={'lg'}>
      <Grid
        container
        spacing={2}
        className="userDashboard"
      >
        <CategoryBox
          category={category}
          handleCategoryCheck={handleCategoryCheck}
          categories={categories}
        />
        <RightContentBox
          category={category}
          share={share}
          shareId={share._id}
          user_id={user_id}
        />
      </Grid>
    </Container>
  );
};

export default AddProductToShare;
